<div class="user-compute-requests">
  <app-table
    [columns]="columns"
    [data]="computeRequestsData"
    [scrollHeight]="'400px'"
    [loading]="loading"
    [pagination]="pagination"
    [emptyMessage]="emptyMessage"
    [striped]="true"
    [bordered]="true"
    [hoverable]="true"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (sortChange)="onSortChange($event)"
  >
    <!-- Custom Status Column -->
    <ng-template #statusCell let-row>
      <div [ngClass]="getStatusChipClass(row.status)">
        {{ row.status }}
      </div>
    </ng-template>

    <!-- Custom Action Column (dropdown in fixed overlay below) -->
    <ng-template #actionCell let-row>
      <div class="action-cell-wrapper">
        <button 
          class="action-btn" 
          (click)="toggleActionDropdown($event, row)"
          [class.active]="isDropdownOpen(row)"
          type="button"
        >
          <span>Action</span>
        </button>
      </div>
    </ng-template>
  </app-table>
</div>

<!-- Fixed overlay: dropdown on top of table -->
<div
  *ngIf="dropdownPosition && openDropdownRow"
  class="action-dropdown-overlay"
  [style.top.px]="dropdownPosition.top"
  [style.left.px]="dropdownPosition.left"
  [style.min-width.px]="dropdownPosition.width"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">
        View Details
      </button>
    </li>
    <li class="dropdown-item">
      <button
        type="button"
        class="dropdown-link"
        [class.disabled]="isRequestProcessed(openDropdownRow)"
        [disabled]="isRequestProcessed(openDropdownRow)"
        (click)="!isRequestProcessed(openDropdownRow) && handleAction('approve', openDropdownRow)"
      >
        Approve
      </button>
    </li>
    <li class="dropdown-item">
      <button
        type="button"
        class="dropdown-link dropdown-link--danger"
        [class.disabled]="isRequestProcessed(openDropdownRow)"
        [disabled]="isRequestProcessed(openDropdownRow)"
        (click)="!isRequestProcessed(openDropdownRow) && handleAction('reject', openDropdownRow)"
      >
        Reject
      </button>
    </li>
  </ul>
</div>

<!-- View Details Modal -->
<app-modal
  [(visible)]="isViewDetailsModalVisible"
  header="Compute Request Details"
  [width]="'520px'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
  (onClose)="closeViewDetailsModal()"
>
  <div class="compute-request-details">
    <div *ngIf="userDetailsLoading" class="details-loading">
      <span class="loading-text">Loading user details...</span>
    </div>
    <ng-container *ngIf="!userDetailsLoading && (userDetails || selectedRequest)">
      <!-- API user details (from admin/user API) -->
      <div class="detail-row" *ngIf="userDetails">
        <span class="detail-label">User Name</span>
        <span class="detail-value">{{ userDetails.userName ?? userDetails.user_name ?? userDetails.name ?? userDetails.email ?? 'N/A' }}</span>
      </div>
      <div class="detail-row" *ngIf="userDetails">
        <span class="detail-label">Email</span>
        <span class="detail-value">{{ userDetails.email ?? userDetails.emailAddress ?? userDetails.registeredEmail ?? 'N/A' }}</span>
      </div>
      <div class="detail-row" *ngIf="userDetails">
        <span class="detail-label">Organisation</span>
        <span class="detail-value">{{ userDetails.organisationName ?? userDetails.organisation_name ?? userDetails.orgName ?? userDetails.organisation?.name ?? 'N/A' }}</span>
      </div>
      <div class="detail-row" *ngIf="userDetails">
        <span class="detail-label">Emp ID</span>
        <span class="detail-value">{{ userDetails.organisation?.empId ?? userDetails.organisation?.emp_id ?? 'N/A' }}</span>
      </div>
      <div class="detail-row" *ngIf="userDetails">
        <span class="detail-label">Job Title</span>
        <span class="detail-value">{{ userDetails.organisation?.jobTitle ?? userDetails.organisation?.job_title ?? userDetails.organisation?.position ?? 'N/A' }}</span>
      </div>
      <div class="detail-row" *ngIf="userDetails && selectedRequest">
        <span class="detail-label">Request Status</span>
        <span class="detail-value" [ngClass]="getStatusChipClass(selectedRequest.status)">{{ selectedRequest.status || 'N/A' }}</span>
      </div>
      <!-- Fallback: request row data when API not called or failed -->
      <ng-container *ngIf="!userDetails && selectedRequest">
        <div class="detail-row">
          <span class="detail-label">User Name</span>
          <span class="detail-value">{{ selectedRequest.userName || 'N/A' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Organisation Name</span>
          <span class="detail-value">{{ selectedRequest.organisationName || 'N/A' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Job Title</span>
          <span class="detail-value">{{ selectedRequest.jobTitle || 'N/A' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Current Role</span>
          <span class="detail-value">{{ selectedRequest.currentRole || 'N/A' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Status</span>
          <span class="detail-value" [ngClass]="getStatusChipClass(selectedRequest.status)">{{ selectedRequest.status || 'N/A' }}</span>
        </div>
      </ng-container>
    </ng-container>
  </div>
</app-modal>
